module.exports = __webpack_public_path__ + "img/citrix_logo.d9751b2c.jpg";